import { useCallback, useEffect, useState, useRef } from 'react';

import formatDistance from 'date-fns/formatDistance';
import pt from 'date-fns/locale/pt';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import Actions from '~/components/Actions';
import Button from '~/components/Button';
import Header from '~/components/Header';
import Pagination from '~/components/Pagination';
import Table from '~/components/Table';
import TableActions from '~/components/TableActions';
import PrivateLayout from '~/layouts/Private';
import api from '~/services/api';

import Form from './Form';
import { Container, Capitalize } from './styles';

const INITIAL_TARIFF_TYPES = {
  data: [],
  page: 0,
  perPage: 0,
  total: 0,
  lastPage: 0,
};

const LodgingTariffType = () => {
  const { id } = useParams();

  const formRef = useRef();

  const [tariffTypes, setTariffTypes] = useState(INITIAL_TARIFF_TYPES);

  const getTariffTypes = useCallback(
    async (page = 1) => {
      try {
        const response = await api.get(
          `lodgings/${id}/tariff-types?page=${page}&perPage=10&active=true&orderBy=updated_at DESC`
        );

        setTariffTypes(response.data);
      } catch (error) {
        toast.error('Erro ao buscar tipos de pensões...');
        setTariffTypes(INITIAL_TARIFF_TYPES);
      }
    },
    [id]
  );

  useEffect(() => {
    getTariffTypes();
  }, [getTariffTypes]);

  const handleClickOpenForm = () =>
    formRef.current.setData({
      type: 'C',
    });

  const handleClickEdit = (data) => formRef.current.setData(data);

  const handleOnCloseForm = (reload) => {
    if (reload) getTariffTypes();
  };

  const columns = [
    {
      key: 'description',
      label: 'Nome',
      format: (name) => <Capitalize>{name}</Capitalize>,
    },
    {
      key: 'updated_at',
      label: 'Atualizado',
      format: (value) =>
        formatDistance(new Date(value), new Date(), {
          locale: pt,
          addSuffix: true,
        }),
    },
    {
      label: '',
      width: 50,
      format: (detail) => {
        return <TableActions onEdit={() => handleClickEdit(detail)} />;
      },
    },
  ];

  return (
    <PrivateLayout>
      <Container>
        <Header title="Tipos de tarifário" total={tariffTypes.total} />
        <Actions align="flex-end">
          <Button
            label="Novo tipo de tarifário"
            onClick={handleClickOpenForm}
          />
        </Actions>
        <Form ref={formRef} onClose={handleOnCloseForm} />
        <Table columns={columns} rows={tariffTypes.data} />
        <Pagination
          onChange={getTariffTypes}
          page={tariffTypes.page}
          perPage={tariffTypes.perPage}
          total={tariffTypes.total}
          lastPage={tariffTypes.lastPage}
          position="flex-end"
        />
      </Container>
    </PrivateLayout>
  );
};

export default LodgingTariffType;
